<template>
  <span
    class="badge"
    :class="{
      'badge-primary': status === statusType.Planned,
      'badge-secondary': status === statusType.Shared,
      'badge-warning': status === statusType.InProgress,
      'badge-success': status === statusType.Done || status === statusType.UnderReview,
      'badge-info': status === statusType.Information,
      'bi-badge': size === 'xl',
      'badge-pill': size !== 'xl',
    }"
    :style="styles"
  >
    {{ status }}
  </span>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import { BoardItemStatusDto } from '@/apiclient/apiclient_generated';

  @Component({})
  export default class BoardItemStatus extends Vue {
    @Prop()
    status: string;

    @Prop()
    size: string;

    @Prop()
    styles: any;

    statusType = BoardItemStatusDto;
  }
</script>

<style scoped lang="scss">
  .bi-badge {
    width: 100%;
    font-size: 1.2rem;
  }
</style>
